import StatusCodes from '@/v2/constants/StatusCodes';
import { notification } from '@/v2/components/Notification/notification';

import onSSOError from './onSSOError';
import onPaymentRequiredError from './onPaymentRequiredError';

export default function onError({ error, query, router, queryClient }) {
  const { meta } = query;
  const httpStatus = error.response?.status;
  if (httpStatus == StatusCodes.UNAUTHORIZED_ERROR_CODE) {
    // Managed by axios interceptors
    return;
  }

  if (httpStatus == StatusCodes.PAYMENT_REQUIRED) {
    onPaymentRequiredError({ router });
    return;
  }

  if (httpStatus == StatusCodes.SSO_INVALID_TOKEN_ERROR_CODE) {
    onSSOError({ error, router, queryClient });
    return;
  }

  const errorMessage = getQueryErrorMessage(meta?.notification?.error, error);
  if (errorMessage === false) {
    return;
  }

  notification.error({
    message: errorMessage,
  });
  return;
}

function getQueryErrorMessage(errorMessageHandler, error) {
  if (errorMessageHandler) {
    if (typeof errorMessageHandler === 'function') {
      return errorMessageHandler(error);
    }
    return errorMessageHandler;
  }
  return error.feedbackData?.message ?? 'There was an error';
}
